import {
  CHANGE_ACTIVE_ITEM_TS_EXPERT,
  CHANGE_ACTIVE_ITEM_LIVELIST,
  CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX,
  CHANGE_ACTIVE_ITEM_OSCILLOSCOPE,
  CHANGE_ACTIVE_ITEM_BAR_GRAPH,
  CHANGE_ACTIVE_ITEM_DADOS,
  CHANGE_ACTIVE_ITEM_LOG,
  CHANGE_ACTIVE_ITEM_REPORT,
  CHANGE_ACTIVE_ITEM_CONFIG,
  CHANGE_ACTIVE_ITEM_CHANNEL,
  SOLVE_PROBLEM
} from "../actions/types";

// ---- Actions ----
export function tsExpertAction(channel) {
  return {
    type: CHANGE_ACTIVE_ITEM_TS_EXPERT,
    payload: { activeItem: "/", channel: channel }
  };
}

export function liveListAction(channel) {
  return {
    type: CHANGE_ACTIVE_ITEM_LIVELIST,
    payload: { activeItem: "/live-list", channel: channel }
  };
}

export function liveListMatrixAction(channel) {
  return {
    type: CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX,
    payload: { activeItem: "/live-list-matrix", channel: channel }
  };
}

export function oscilloscopeAction(channel) {
  return {
    type: CHANGE_ACTIVE_ITEM_OSCILLOSCOPE,
    payload: { activeItem: "/oscilloscope", channel: channel }
  };
}

export function barGraphAction(channel) {
  return {
    type: CHANGE_ACTIVE_ITEM_BAR_GRAPH,
    payload: { activeItem: "/bar-graph", channel: channel }
  };
}

export function dadosAction(channel) {
  return {
    type: CHANGE_ACTIVE_ITEM_DADOS,
    payload: { activeItem: "/dados", channel: channel }
  };
}

export function logAction(channel) {
  return {
    type: CHANGE_ACTIVE_ITEM_LOG,
    payload: { activeItem: "/log", channel: channel }
  };
}

export function reportAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_REPORT,
    payload: { activeItem: "/report" }
  };
}

export function configAction(channel) {
  return {
    type: CHANGE_ACTIVE_ITEM_CONFIG,
    payload: { activeItem: "/config", channel: channel }
  };
}

// ------------------ Channels ------------------
export function channelAction(channel) {
  return {
    type: CHANGE_ACTIVE_ITEM_CHANNEL,
    payload: { activeItem: "/", channel: channel }
  };
}

// ------------------ Solve Problem ------------------
export function solveProblemAction(solve, problem) {
  return {
    type: SOLVE_PROBLEM,
    payload: { 
      solve: solve,
      problem: problem 
    }
  };
}